class HeaderScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.safeZone = 50
    if (
      this?.externalEls?.['collection-header']?.exists &&
      window.innerWidth < 901
    ) {
      this.safeZone = this.externalEls['collection-header'].element.offsetHeight
    }
    if (document.querySelector('.clc-Hero')) {
      this.safeZone =
        document.querySelector('.clc-Hero').offsetHeight -
        this.offsetHeight -
        this.externalEls['collection-header'].element.offsetHeight
    }

    this.initialMobileColour = document.body.dataset.initialMobileColour
    this.initialDesktopColour = document.body.dataset.initialDesktopColour

    this.measureHeaderHeight()
    this.setColour()
    this.measureCollectionHeaderHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.measureHeaderHeight = this.measureHeaderHeight.bind(this)
    this.measureCollectionHeaderHeight = this.measureCollectionHeaderHeight.bind(
      this,
    )

    window.addEventListener('scroll', this.onScroll, { passive: true })

    window.addEventListener('resize', this.measureHeaderHeight)
    window.addEventListener('resize', this.measureCollectionHeaderHeight)
  }

  measureHeaderHeight () {
    document.documentElement.style.setProperty(
      '--HeaderHeight',
      `${this.offsetHeight}px`,
    )
  }

  measureCollectionHeaderHeight () {
    if (!this?.externalEls?.['collection-header']?.exists) return

    document.documentElement.style.setProperty(
      '--CollectionHeaderHeight',
      `${this.externalEls['collection-header'].element.offsetHeight}px`,
    )

    if (window.innerWidth < 901) {
      this.safeZone = this.externalEls['collection-header'].element.offsetHeight
    }
    if (document.querySelector('.clc-Hero')) {
      this.safeZone =
        document.querySelector('.clc-Hero').offsetHeight -
        this.offsetHeight -
        this.externalEls['collection-header'].element.offsetHeight
    }
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setStyle()
    this.setColour()
  }

  setStyle () {
    document.body.classList.toggle(
      this.dataset.classScrolled,
      this.headerIsScrolled,
    )
  }

  setColour () {
    if (
      window.innerWidth < 901 &&
      document.body.classList.contains('lyt-Site-headerMobileDifference')
    ) {
      return
    }
    if (
      window.innerWidth < 901 &&
      document.body.classList.contains('lyt-Site-headerMobileWhiteBackground')
    ) {
      return
    }
    if (
      window.innerWidth < 901 &&
      document.body.classList.contains('lyt-Site-headerMobileBlackBackground')
    ) {
      return
    }
    if (
      window.innerWidth > 900 &&
      document.body.classList.contains('lyt-Site-headerDesktopDifference')
    ) {
      return
    }

    if (this?.externalEls?.section?.exists) {
      this.elementsOverlapping()
    }
  }

  elementsOverlapping () {
    const header = this.getBoundingClientRect()

    this.externalEls.section.elements.some(sectionEl => {
      const section = sectionEl.getBoundingClientRect()
      if (
        section.top <= header.top &&
        section.top + section.height > header.top
      ) {
        this.mobileColour = `lyt-Site-headerMobile${sectionEl.dataset.mobileColour}`
        this.desktopColour = `lyt-Site-headerDesktop${sectionEl.dataset.desktopColour}`

        if (document.body.classList.contains(this.initialMobileColour)) {
          document.body.classList.remove(this.initialMobileColour)
        }
        if (document.body.classList.contains(this.initialDesktopColour)) {
          document.body.classList.remove(this.initialDesktopColour)
        }
        if (!document.body.classList.contains(this.mobileColour)) {
          document.body.classList.add(this.mobileColour)
        }
        if (!document.body.classList.contains(this.desktopColour)) {
          document.body.classList.add(this.desktopColour)
        }

        return true
      }

      if (document.body.classList.contains(this.mobileColour)) {
        document.body.classList.remove(this.mobileColour)
      }
      if (document.body.classList.contains(this.desktopColour)) {
        document.body.classList.remove(this.desktopColour)
      }
      if (!document.body.classList.contains(this.initialMobileColour)) {
        document.body.classList.add(this.initialMobileColour)
      }
      if (!document.body.classList.contains(this.initialDesktopColour)) {
        document.body.classList.add(this.initialDesktopColour)
      }

      return false
    })
  }

  get headerIsScrolled () {
    return this.lastKnownY >= this.safeZone
  }
}

if (!customElements.get('header-scroll')) {
  customElements.define('header-scroll', HeaderScroll)
}
